import config from "./config";

export default (modulesContainer: HTMLElement) => {
  const analyze = () => {
    let overrides: Record<string, string[]> = {};
    let mediaOverrides: Record<string, Record<string, string[]>> = {};
    const styleSheets = Array.from(document.styleSheets);
    for (const sheet of styleSheets) {
      try {
        const cssRules = Array.from(sheet.cssRules);
        for (const rule of cssRules) {
          if (rule.cssText.includes("font-size") || rule.cssText.includes("line-height") || rule.cssText.includes("word-spacing") || rule.cssText.includes("letter-spacing")) {
            if (rule.cssText.includes('@media')) {
              const matches = <Array<string>> rule.cssText.match('([^{]+){([^{]+{[^}]+})[^}]*}');

              const mediaSelector = matches[1].trim();
              const mediaRules = matches[2].replace('\n', '').trim();

              const innerMatches = <Array<string>> mediaRules.match('([^{]+){([^}]+)}');
              const selector = innerMatches[1].trim();
              const rules = innerMatches[2].trim().split(/;\s|;/).filter(i => i);

              if (selector != ':not(style):not(script):not(noscript)' && !selector.includes('a11y')) {
                const transposedRules = rules
                .filter(rule => rule.startsWith("line-height") || rule.startsWith("font-size") || rule.startsWith("word-spacing") || rule.startsWith("letter-spacing"))
                .map(rule => {
                  const [prop, value] = rule.split(":").map(s => s.trim());

                  if (value != 'inherit') {
                    return `${prop}: calc(${value} * var(--accessibility-${prop}))`;
                  } else {
                    return rule;
                  }
                });

                if (transposedRules.length > 0) {
                  if (!Object.hasOwn(mediaOverrides, mediaSelector)) {
                    mediaOverrides[mediaSelector] = {};
                  }

                  if (!Object.hasOwn(mediaOverrides[mediaSelector], selector)) {
                    mediaOverrides[mediaSelector][selector] = [];
                  }

                  mediaOverrides[mediaSelector][selector] = mediaOverrides[mediaSelector][selector].concat(transposedRules);
                }
              }
            } else {
              const matches = <Array<string>> rule.cssText.match('([^{]+){([^}]+)}');
              const selector = matches[1].trim();
              const rules = matches[2].trim().split(/;\s|;/).filter(i => i);

              if (selector != ':not(style):not(script):not(noscript)' && !selector.includes('a11y')) {
                const transposedRules = rules
                .filter(rule => rule.startsWith("line-height") || rule.startsWith("font-size") || rule.startsWith("word-spacing") || rule.startsWith("letter-spacing"))
                .map(rule => {
                  const [prop, value] = rule.split(":").map(s => s.trim());
                  if (value != 'inherit')
                    return `${prop}: calc(${value} * var(--accessibility-${prop}))`;
                  else {
                    return rule;
                  }
                });

                if (transposedRules.length > 0) {
                  overrides[selector] = transposedRules;
                }
              }
            }
          }
        }
      } catch (e) {
        console.warn("Can't read stylesheet rules for:", sheet.href);
      }
    }

    let styleOverride = '';
    for (const [selector, rules] of Object.entries(overrides)) {
      styleOverride += selector + ' {\n';
      rules.forEach((rule) => {
        styleOverride += '\t' + rule + ' !important;\n';
      });
      styleOverride += '}\n\n';
    }

    let mediaStyleOverride = '';
    for (const [mediaSelector, selectors] of Object.entries(mediaOverrides)) {
      mediaStyleOverride += mediaSelector + ' {\n';

      for (const [selector, rules] of Object.entries(selectors)) {
        mediaStyleOverride += '\t' + selector + ' {\n';

        rules.forEach((rule) => {
          mediaStyleOverride += '\t\t' + rule + ' !important;\n';
        });

        mediaStyleOverride += '\t}\n\n';
      }

      mediaStyleOverride += '}\n\n';
    }

    console.log(styleOverride + '\n' + mediaStyleOverride);
  }

  if (config.devMode) {
    const runAnalyzerElement = document.createElement("div");
    runAnalyzerElement.className = "a11y-module a11y-module-analyzer";
    runAnalyzerElement.innerHTML = `
    <label for="a11y-analyzer">CSS Analysieren</label>
    <button>Analyse Starten</button>
    `;
    modulesContainer.appendChild(runAnalyzerElement);

    const analyzerButton = runAnalyzerElement.querySelector('button');
    analyzerButton?.addEventListener("click", () => {
      analyze();
    });
  }
}